/**
 * Utility for storing and retrieving column order in localStorage
 */

const LOCAL_STORAGE_PREFIX = 'table_column_order_';

/**
 * Get the stored column order for a specific table
 * @param {string} tableId - Unique identifier for the table
 * @returns {Array|null} - Array of column IDs or null if not found
 */
export const getColumnOrder = (tableId) => {
  if (!tableId) return null;
  
  try {
    const key = `${LOCAL_STORAGE_PREFIX}${tableId}`;
    const storedValue = localStorage.getItem(key);
    
    if (!storedValue) return null;
    
    return JSON.parse(storedValue);
  } catch (error) {
    console.error('Error getting column order from localStorage:', error);
    return null;
  }
};

/**
 * Store the column order for a specific table
 * @param {string} tableId - Unique identifier for the table
 * @param {Array} columnOrder - Array of column IDs in order
 */
export const setColumnOrder = (tableId, columnOrder) => {
  if (!tableId || !columnOrder) return;
  
  try {
    const key = `${LOCAL_STORAGE_PREFIX}${tableId}`;
    localStorage.setItem(key, JSON.stringify(columnOrder));
  } catch (error) {
    console.error('Error setting column order in localStorage:', error);
  }
};

/**
 * Reset the column order for a specific table to default
 * @param {string} tableId - Unique identifier for the table
 */
export const resetColumnOrder = (tableId) => {
  if (!tableId) return;
  
  try {
    const key = `${LOCAL_STORAGE_PREFIX}${tableId}`;
    localStorage.removeItem(key);
  } catch (error) {
    console.error('Error resetting column order in localStorage:', error);
  }
};

// Export the methods directly
export const columnOrderStorage = {
  getColumnOrder,
  setColumnOrder,
  resetColumnOrder
};

// Default export for backward compatibility
export default {
  getColumnOrder,
  setColumnOrder,
  resetColumnOrder
};